import {useState} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {FormProviderRHF, useFormRHF} from "@pg-mono/react-hook-forms-utils";
import type {IAppError} from "@pg-mono/request-state";

import {LeadButtonTerms} from "../../../lead/components/LeadButtonTerms";
import {LeadRodoTerms} from "../../../lead/components/LeadRodoTerms";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {userSignUpHit} from "../../../tracking/algolytics_hits/user_sign_up_hit";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {UserMktOptins} from "../../../user/components/UserMktOptins";
import {UserAccountType} from "../../../user/types/UserAccountType";
import {authSucceeded} from "../../actions/auth_succeeded_event";
import {emailSignUp} from "../../api/email_sign_up";
import {registerFormDefaultValues} from "../../constants/register_form_default_values";
import {registerFormValidationSchema} from "../../constants/register_form_validation_schema";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "../../tracking/auth_analytics";
import {AuthActionType} from "../../types/AuthActionType";
import type {IRegister} from "../../types/IRegister";

interface IProps {
    onSuccessfulSubmit?: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    gtmEventData?: () => void;
}

const registerButtonText = "Zarejestruj się";

export const RegisterForm = (props: IProps) => {
    const {onSuccessfulSubmit, userSource, gtmSourceSection, gtmEventData} = props;
    const dispatch = useAppDispatch();

    const [isSubmitting, setIsSubmitting] = useState(false);

    const currentViewType = useAppSelector((state) => state.viewType.current);
    const countryCodes = useAppSelector((state) => state.variables.data?.country_codes ?? []);

    const methods = useFormRHF<IRegister>({defaultValues: registerFormDefaultValues, resolver: yupResolver(registerFormValidationSchema)});

    const marketingSms = methods.watch("marketing_sms");

    const onSubmit = ({email, marketing_email, marketing_sms, password, phone}: IRegister) => {
        setIsSubmitting(true);
        emailSignUp({
            email,
            password,
            ...(marketing_sms ? {phone: `${phone.code} ${phone.number}`} : {}),
            type: UserAccountType.LOCAL,
            marketing_sms,
            marketing_email
        })
            .then(async (response) => {
                authAnalytics.gtm.emailAuthEvent({
                    event: GAAuthEventName.SIGN_UP,
                    eventCategory: GAAuthEventCategory.REGISTRATION_FORM,
                    source: gtmSourceSection ?? null,
                    userSource
                });

                dispatch(
                    authSucceeded({
                        type: AuthActionType.REGISTRATION,
                        userSource,
                        gtmSourceSection,
                        registrationMethod: "email"
                    })
                );
                userSignUpHit(userSource, response, currentViewType);
                gtmEventData?.();
                onSuccessfulSubmit?.();
            })
            .catch((error: {appError?: IAppError}) => {
                if (error.appError?.fieldErrors) {
                    for (const field of Object.keys(error.appError.fieldErrors)) {
                        const message = error.appError.fieldErrors[field];

                        methods.setError(field as keyof IRegister, {
                            message: Array.isArray(message) ? message.join(", ") : message
                        });
                    }
                }

                if (error.appError?.nonFieldErrors && error.appError.nonFieldErrors.length) {
                    dispatch(addNotification({notification: {content: error.appError.nonFieldErrors.join(" "), type: "failure"}}));
                }
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <FormProviderRHF {...methods}>
            <form className={form} onSubmit={methods.handleSubmit(onSubmit)}>
                <InputField name="email" placeholder="E-mail" />
                <InputField name="password" placeholder="Hasło" type="password" />

                {marketingSms && <PhoneFieldControlled name="phone" codes={countryCodes} placeholder="Telefon" />}

                <UserMktOptins showForm initialValues={registerFormDefaultValues} formId={`${currentViewType}_register`} />

                <Button className={submit} type="submit" variant="filled_primary" isLoading={isSubmitting}>
                    {registerButtonText}
                </Button>
                <div className={leadTerms}>
                    <LeadButtonTerms buttonText={registerButtonText} />
                    <LeadRodoTerms />
                </div>
            </form>
        </FormProviderRHF>
    );
};

const form = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 2
});

const submit = css({
    width: "100%",
    marginTop: 1
});

const leadTerms = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    pb: 2,
    textAlign: "center"
});
import {useState} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {FormProviderRHF, useFormRHF} from "@pg-mono/react-hook-forms-utils";
import type {IAppError} from "@pg-mono/request-state";

import {LeadButtonTerms} from "../../../lead/components/LeadButtonTerms";
import {LeadRodoTerms} from "../../../lead/components/LeadRodoTerms";
import {addNotification} from "../../../notifications/state/notifications_slice";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {userSignUpHit} from "../../../tracking/algolytics_hits/user_sign_up_hit";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {UserMktOptins} from "../../../user/components/UserMktOptins";
import {UserAccountType} from "../../../user/types/UserAccountType";
import {authSucceeded} from "../../actions/auth_succeeded_event";
import {emailSignUp} from "../../api/email_sign_up";
import {registerFormDefaultValues} from "../../constants/register_form_default_values";
import {registerFormValidationSchema} from "../../constants/register_form_validation_schema";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "../../tracking/auth_analytics";
import {AuthActionType} from "../../types/AuthActionType";
import type {IRegister} from "../../types/IRegister";

interface IProps {
    onSuccessfulSubmit?: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    gtmEventData?: () => void;
}

const registerButtonText = "Zarejestruj się";

export const RegisterForm = (props: IProps) => {
    const {onSuccessfulSubmit, userSource, gtmSourceSection, gtmEventData} = props;
    const dispatch = useAppDispatch();

    const [isSubmitting, setIsSubmitting] = useState(false);

    const currentViewType = useAppSelector((state) => state.viewType.current);
    const countryCodes = useAppSelector((state) => state.variables.data?.country_codes ?? []);

    const methods = useFormRHF<IRegister>({defaultValues: registerFormDefaultValues, resolver: yupResolver(registerFormValidationSchema)});

    const marketingSms = methods.watch("marketing_sms");

    const onSubmit = ({email, marketing_email, marketing_sms, password, phone}: IRegister) => {
        setIsSubmitting(true);
        emailSignUp({
            email,
            password,
            ...(marketing_sms ? {phone: `${phone.code} ${phone.number}`} : {}),
            type: UserAccountType.LOCAL,
            marketing_sms,
            marketing_email
        })
            .then(async (response) => {
                authAnalytics.gtm.emailAuthEvent({
                    event: GAAuthEventName.SIGN_UP,
                    eventCategory: GAAuthEventCategory.REGISTRATION_FORM,
                    source: gtmSourceSection ?? null,
                    userSource
                });

                dispatch(
                    authSucceeded({
                        type: AuthActionType.REGISTRATION,
                        userSource,
                        gtmSourceSection,
                        registrationMethod: "email"
                    })
                );
                userSignUpHit(userSource, response, currentViewType);
                gtmEventData?.();
                onSuccessfulSubmit?.();
            })
            .catch((error: {appError?: IAppError}) => {
                if (error.appError?.fieldErrors) {
                    for (const field of Object.keys(error.appError.fieldErrors)) {
                        const message = error.appError.fieldErrors[field];

                        methods.setError(field as keyof IRegister, {
                            message: Array.isArray(message) ? message.join(", ") : message
                        });
                    }
                }

                if (error.appError?.nonFieldErrors && error.appError.nonFieldErrors.length) {
                    dispatch(addNotification({notification: {content: error.appError.nonFieldErrors.join(" "), type: "failure"}}));
                }
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <FormProviderRHF {...methods}>
            <form className={form} onSubmit={methods.handleSubmit(onSubmit)}>
                <InputField name="email" placeholder="E-mail" />
                <InputField name="password" placeholder="Hasło" type="password" />

                {marketingSms && <PhoneFieldControlled name="phone" codes={countryCodes} placeholder="Telefon" />}

                <UserMktOptins showForm initialValues={registerFormDefaultValues} formId={`${currentViewType}_register`} />

                <Button className={submit} type="submit" variant="filled_primary" isLoading={isSubmitting}>
                    {registerButtonText}
                </Button>
                <div className={leadTerms}>
                    <LeadButtonTerms buttonText={registerButtonText} />
                    <LeadRodoTerms />
                </div>
            </form>
        </FormProviderRHF>
    );
};

const form = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 2
});

const submit = css({
    width: "100%",
    marginTop: 1
});

const leadTerms = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    pb: 2,
    textAlign: "center"
});
